import React from 'react';
import { Helmet } from 'react-helmet';

const apiLinks = [
  import.meta.env.VITE_API_CORE_ENDPOINT,
  import.meta.env.VITE_API_NOTIFICATION_ENDPOINT,
  import.meta.env.VITE_API_MESSAGING_ENDPOINT,
];

const links = apiLinks.filter(Boolean).map((link) => link.replace('/api', ''));

export default function Preconnect() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link rel="preconnect" href="https://analytics.google.com" />
      <link rel="preconnect" href="https://maps.googleapis.com" />
      {links.map((link, i) => (
        <link key={i} rel="preconnect" href={link} />
      ))}
    </Helmet>
  );
}
